<div class="modal fade stamp-wizard-modal" [id]="modalId" tabindex="-1" aria-hidden="true"
    data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" [class.stamp-wizard-dialog--wide]="step === 2 || step === 4">
        <div class="modal-content stamp-wizard-content">

            <!-- Paso 1: Seleccionar recibos -->
            <ng-container *ngIf="step === 1">
                <div class="stamp-wizard-header">
                    <div class="stamp-wizard-header-text">
                        <div class="stamp-wizard-header-title-row">
                            <span class="stamp-wizard-step-badge">1</span>
                            <p class="stamp-wizard-title">Seleccionar recibos</p>
                        </div>
                        <p class="stamp-wizard-subtitle">Elige los recibos que deseas timbrar</p>
                    </div>
                    <button type="button" class="stamp-wizard-close-btn" (click)="cancel()" aria-label="Cerrar">
                        <i class="ti ti-x"></i>
                    </button>
                </div>

                <div class="stamp-wizard-selection-header">
                    <p class="stamp-wizard-selection-title">Selecciona los recibos a timbrar</p>
                    <label class="stamp-wizard-select-all">
                        <input type="checkbox" [checked]="allSelected" (change)="toggleAll($any($event.target).checked)">
                        <span>Seleccionar todos los recibos listos ({{receipts.length}})</span>
                    </label>
                </div>

                <div class="stamp-wizard-list-area">
                    <div *ngIf="loadingList" class="stamp-wizard-empty">Cargando recibos...</div>
                    <div *ngIf="!loadingList && receipts.length === 0" class="stamp-wizard-empty">
                        No hay recibos pendientes o con error para timbrar.
                    </div>
                    <div class="stamp-wizard-row" *ngFor="let r of receipts">
                        <input type="checkbox" [(ngModel)]="r.selected">
                        <span class="stamp-wizard-row-name">{{r.employee_name}}</span>
                        <span class="stamp-wizard-row-period">{{r.period_label}}</span>
                        <span class="stamp-wizard-row-amount">{{formatCurrency(r.net_paid)}}</span>
                    </div>
                </div>

                <div class="stamp-wizard-footer">
                    <p class="stamp-wizard-selected-count">{{selectedCount}} seleccionados</p>
                    <div class="stamp-wizard-actions">
                        <button type="button" class="stamp-wizard-btn stamp-wizard-btn-outline" (click)="cancel()">Cancelar</button>
                        <button type="button" class="stamp-wizard-btn stamp-wizard-btn-primary" [disabled]="selectedCount === 0"
                            (click)="goToValidation()">Continuar</button>
                    </div>
                </div>
            </ng-container>

            <!-- Paso 2: Validación de información -->
            <ng-container *ngIf="step === 2">
                <div class="stamp-wizard-header">
                    <div class="stamp-wizard-header-text">
                        <div class="stamp-wizard-header-title-row">
                            <span class="stamp-wizard-step-badge">2</span>
                            <p class="stamp-wizard-title">Validación de información</p>
                        </div>
                        <p class="stamp-wizard-subtitle">Verificamos que la información esté completa y correcta</p>
                    </div>
                    <button type="button" class="stamp-wizard-close-btn" (click)="cancel()" aria-label="Cerrar">
                        <i class="ti ti-x"></i>
                    </button>
                </div>

                <div class="stamp-wizard-scroll-content">
                    <div *ngIf="loadingValidation" class="stamp-wizard-empty">Validando información...</div>

                    <ng-container *ngIf="!loadingValidation && validation">
                        <div class="stamp-wizard-summary-card">
                            <div class="stamp-wizard-summary-header">
                                <strong>{{validation.total}} recibos</strong>
                                <span>analizados</span>
                            </div>
                            <div class="stamp-wizard-summary-item" *ngFor="let cat of validation.categories">
                                <div class="stamp-wizard-summary-item-left">
                                    <i class="ti"
                                        [ngClass]="categoryIcon(cat) === 'check' ? 'ti-circle-check stamp-wizard-stat-icon--success' : (cat.severity === 'warning' ? 'ti-alert-circle stamp-wizard-stat-icon--warning' : 'ti-alert-circle stamp-wizard-stat-icon--error')"></i>
                                    <span>{{cat.label}}</span>
                                </div>
                                <span class="stamp-wizard-summary-item-value"
                                    [class.is-warning]="cat.issue_count > 0 && cat.severity === 'warning'"
                                    [class.is-error]="cat.issue_count > 0 && cat.severity === 'error'">
                                    {{categoryDisplayText(cat)}}
                                </span>
                            </div>
                        </div>

                        <div class="stamp-wizard-workers-section">
                            <p class="stamp-wizard-workers-title">Trabajadores con errores ({{workersWithErrorsCount}})</p>
                            <div class="stamp-wizard-workers-card" *ngIf="workersWithErrorsCount > 0">
                                <div class="stamp-wizard-worker-row" *ngFor="let w of validation.workers_with_errors">
                                    <span class="stamp-wizard-worker-dot"></span>
                                    <div class="stamp-wizard-worker-text">
                                        <p class="stamp-wizard-worker-name">{{w.employee_name}}</p>
                                        <p class="stamp-wizard-worker-message" *ngIf="w.message">{{w.message}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="stamp-wizard-empty" *ngIf="workersWithErrorsCount === 0">Sin errores detectados.</div>

                            <label class="stamp-wizard-exclude-checkbox">
                                <input type="checkbox" [(ngModel)]="excludeErrored" [disabled]="workersWithErrorsCount === 0">
                                <span>Excluir automáticamente registros con error</span>
                            </label>
                        </div>
                    </ng-container>

                    <div *ngIf="!loadingValidation && !validation" class="stamp-wizard-empty">
                        No se pudo validar la información de los colaboradores seleccionados.
                    </div>
                </div>

                <div class="stamp-wizard-footer">
                    <button type="button" class="stamp-wizard-btn stamp-wizard-btn-outline" (click)="cancel()">Cancelar</button>
                    <div class="stamp-wizard-actions">
                        <button type="button" class="stamp-wizard-btn stamp-wizard-btn-outline" (click)="backToSelection()">Volver</button>
                        <button type="button" class="stamp-wizard-btn stamp-wizard-btn-primary" [disabled]="loadingValidation"
                            (click)="goToConfirmation()">Continuar</button>
                    </div>
                </div>
            </ng-container>

            <!-- Paso 3: Confirmación -->
            <ng-container *ngIf="step === 3">
                <div class="stamp-wizard-body">
                    <div class="stamp-wizard-header-row">
                        <div class="stamp-wizard-header-left">
                            <span class="stamp-wizard-step-badge">3</span>
                            <p class="stamp-wizard-title">Confirmación</p>
                        </div>
                        <button type="button" class="stamp-wizard-close-btn" (click)="cancel()" aria-label="Cerrar">
                            <i class="ti ti-x"></i>
                        </button>
                    </div>
                    <p class="stamp-wizard-subtitle">Revisa el resumen antes de timbrar</p>

                    <div class="stamp-wizard-hero-box">
                        <i class="ti ti-file-invoice stamp-wizard-hero-icon"></i>
                        <div>
                            <p class="stamp-wizard-hero-line">Se enviarán</p>
                            <p class="stamp-wizard-hero-value">{{selectedCount}} CFDI</p>
                            <p class="stamp-wizard-hero-line">al PAC para timbrado</p>
                        </div>
                    </div>

                    <div class="stamp-wizard-summary-list">
                        <div class="stamp-wizard-summary-row">
                            <span>Periodo de pago</span>
                            <strong>{{selectedPeriodLabel}}</strong>
                        </div>
                        <div class="stamp-wizard-summary-row">
                            <span>Recibos a timbrar</span>
                            <strong>{{selectedCount}}</strong>
                        </div>
                        <div class="stamp-wizard-summary-row">
                            <span>Neto total a pagar</span>
                            <strong>{{formatCurrency(selectedTotal)}}</strong>
                        </div>
                        <div class="stamp-wizard-summary-row">
                            <span>Tiempo estimado</span>
                            <strong>{{estimatedTimeLabel}}</strong>
                        </div>
                    </div>
                </div>

                <div class="stamp-wizard-action-footer">
                    <button type="button" class="stamp-wizard-btn stamp-wizard-btn-outline" (click)="cancel()">Cancelar</button>
                    <button type="button" class="stamp-wizard-btn stamp-wizard-btn-outline" (click)="backToValidation()">Volver</button>
                    <button type="button" class="stamp-wizard-btn stamp-wizard-btn-primary stamp-wizard-btn-stamp"
                        *ngIf="canDo('Timbrar')" (click)="startStamping()">
                        <i class="ti ti-qrcode"></i>
                        Timbrar {{selectedCount}} recibos
                    </button>
                </div>
            </ng-container>

            <!-- Paso 4: Proceso de timbrado -->
            <ng-container *ngIf="step === 4">
                <div class="stamp-wizard-header">
                    <div class="stamp-wizard-header-left">
                        <span class="stamp-wizard-step-badge">4</span>
                        <p class="stamp-wizard-title">Proceso de timbrado</p>
                    </div>
                    <button type="button" class="stamp-wizard-close-btn" (click)="cancel()" aria-label="Cerrar"
                        [disabled]="batch?.status !== 'completed'">
                        <i class="ti ti-x"></i>
                    </button>
                </div>

                <div class="stamp-wizard-progress-body">
                    <p class="stamp-wizard-subtitle">Estamos timbrando los CFDI, por favor no cierres esta ventana.</p>

                    <div class="stamp-wizard-progress-section">
                        <div class="stamp-wizard-progress-labels">
                            <span>Progreso general</span>
                            <span>{{batch?.processed || 0}} / {{batch?.total || 0}} CFDIs</span>
                        </div>
                        <div class="stamp-wizard-progress-bar-container">
                            <div class="stamp-wizard-progress-track">
                                <div class="stamp-wizard-progress-fill" [style.width.%]="batch?.percent || 0"></div>
                            </div>
                            <span class="stamp-wizard-progress-percent">{{batch?.percent || 0}}%</span>
                        </div>
                    </div>

                    <div class="stamp-wizard-stats-row">
                        <div class="stamp-wizard-stat-card">
                            <div class="stamp-wizard-stat-head">
                                <span>Timbrados</span>
                                <i class="ti ti-circle-check stamp-wizard-stat-icon--success"></i>
                            </div>
                            <p class="stamp-wizard-stat-value">{{batch?.stamped_count || 0}}</p>
                        </div>
                        <div class="stamp-wizard-stat-card">
                            <div class="stamp-wizard-stat-head">
                                <span>En proceso</span>
                                <i class="ti ti-loader-2 stamp-wizard-stat-icon--info"></i>
                            </div>
                            <p class="stamp-wizard-stat-value">{{processingCount}}</p>
                        </div>
                        <div class="stamp-wizard-stat-card">
                            <div class="stamp-wizard-stat-head">
                                <span>Con error</span>
                                <i class="ti ti-alert-triangle stamp-wizard-stat-icon--error"></i>
                            </div>
                            <p class="stamp-wizard-stat-value">{{batch?.error_count || 0}}</p>
                        </div>
                        <div class="stamp-wizard-stat-card">
                            <div class="stamp-wizard-stat-head">
                                <span>Omitidas</span>
                                <i class="ti ti-alert-triangle stamp-wizard-stat-icon--warning"></i>
                            </div>
                            <p class="stamp-wizard-stat-value">{{batch?.skipped_count || 0}}</p>
                        </div>
                    </div>

                    <div class="stamp-wizard-detail-section">
                        <p class="stamp-wizard-detail-title">Detalle del proceso</p>
                        <div class="stamp-wizard-table">
                            <div class="stamp-wizard-table-header">
                                <span class="col-colaborador">Colaborador</span>
                                <span class="col-estado">Estado</span>
                                <span class="col-mensaje">Mensaje</span>
                                <span class="col-tiempo">Tiempo</span>
                            </div>
                            <div class="stamp-wizard-table-row" *ngFor="let item of visibleItems">
                                <span class="col-colaborador">{{item.employee_name}}</span>
                                <span class="col-estado">
                                    <span class="stamp-wizard-status-badge" [ngClass]="'status--' + item.status">
                                        {{statusLabel(item.status)}}
                                    </span>
                                </span>
                                <span class="col-mensaje">{{item.status === 'processing' ? 'Procesando...' : (item.message || '--')}}</span>
                                <span class="col-tiempo">{{item.duration_ms ? (item.duration_ms / 1000).toFixed(1) + 's' : '--'}}</span>
                            </div>
                        </div>
                        <div class="stamp-wizard-ver-todos" *ngIf="hasMoreItems">
                            <a href="javascript:void(0)" (click)="showAllItems = true">Ver todos...</a>
                        </div>
                    </div>
                </div>

                <div class="stamp-wizard-info-footer" *ngIf="batch?.status !== 'completed'">
                    <i class="ti ti-info-circle"></i>
                    <span>Esta ventana se cerrará automáticamente al finalizar el proceso.</span>
                </div>
                <div class="stamp-wizard-info-footer stamp-wizard-info-footer--done" *ngIf="batch?.status === 'completed'">
                    <i class="ti ti-circle-check"></i>
                    <span>Proceso de timbrado finalizado.</span>
                </div>
            </ng-container>

        </div>
    </div>
</div>
